import { StorePagination } from "../../../../DashboardPagination"
import { producttypeActions } from "../../../../../store/producttype-slice"

const Pagination = ({ index }) => {
    return <StorePagination index={index} sliceName="producttype" actions={producttypeActions} label="Produkttypen Seitennavigation" />
}

export default Pagination;
